import { useCallback, useEffect, useState } from "react"

interface Input {
    regex: RegExp
    callback: (value: string) => void
}

let debounced:any;
export const SCALE_WEIGHT_REGEX = /([0-9]*[.,][0-9]*\s?[kgKG]*)/
export const ALPHA_NUMERIC_REGEX = /([0-9a-zA-Z-]*)/

const inputCleanup = (input: string) => {
    // remove spaces, question marks, slashes hashes.
    return input?.replace(/[\s?#/]/g, "") || ""
}

const useKeyboardTimedInput = (enabled: boolean, inputs: Input[]) => {
    const [input, setInput] = useState<string>("")

    const parseToInputs = useCallback(
        (text: any) => {
            let t = inputCleanup(text)
            if (enabled && t) {
                for (const { regex, callback } of inputs) {
                    if (regex.test(t)) {
                        // @ts-ignore
                        callback(t.match(regex)?.[0])
                        setInput("")
                        break
                    }
                }
            }
        },
        [inputs, enabled]
    )

    useEffect(() => {
        if (enabled && input) {
            clearTimeout(debounced)
            debounced = setTimeout(() => parseToInputs(input.trim().toLowerCase()), 200)
        }
        return () => debounced && clearTimeout(debounced)
    }, [enabled, input, parseToInputs])

    useEffect(() => {
        const event = (event: KeyboardEvent) => {
            
            if (enabled  && !["Shift", "Control", "Meta", "Alt", "Enter", "Backspace", "Escape"].includes(event.key)) {
                setInput && setInput((prev) => prev + event.key)
            }
        }

        window.addEventListener("keypress", event)
        return () => {
            window.removeEventListener("keypress", event)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [enabled, inputs])
}

export default useKeyboardTimedInput
